import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Company, Employee } from '@models/company';
import { MatterDispatch } from '@state/matter';

@Component({
	selector: 'app-condo-corporation-attention-contact-modal',
	templateUrl: './condo-corporation-attention-contact-modal.component.html',
	standalone: false,
})
export class CondoCorporationAttentionContactModalComponent {
	public employee: Employee;
	public company: Company;
	public checkboxLabel: string;

	constructor(
		private matterDispatch: MatterDispatch,
		public dialogRef: MatDialogRef<CondoCorporationAttentionContactModalComponent>,
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		@Inject(MAT_DIALOG_DATA) public data: any,
	) {
		this.company = data.company ?? null;
		this.employee = data.employee ?? null;
		this.checkboxLabel = data.checkboxLabel ?? null;
	}

	onCreate(contactEmployee: Employee) {
		this.matterDispatch.OverwriteFields(
			'condoCorporation.attention.person',
			contactEmployee,
		);
		this.dialogRef.close();
	}

	onCancel() {
		this.dialogRef.close();
	}
}
